module.exports = __webpack_public_path__ + "img/icon_approve_add.e79f2cd9.png";